import mqtt from 'mqtt';
import { ec as EC } from 'elliptic';
import { sha256 } from 'js-sha256';
import * as state from './state';
import { generateFingerprint } from './crypto';
import { displayIncomeMessages, renderConversationList } from '../ui/render';
import { soundUrls } from '../ui/soundboard';

const brokerUrl = 'wss://test.mosquitto.org:8081/mqtt';
const clientId = 'mqtt_chat_' + Math.random().toString(16).substr(2, 8);
export const client = mqtt.connect(brokerUrl, { clientId: clientId });

export function subscribeToPersonalTopic() {
    if (state.personalTopic) {
        client.unsubscribe(state.personalTopic, (err) => {
            if (err) console.error(`Error unsubscribing from ${state.personalTopic}`, err);
        });
    }
    if (state.userFingerprint) {
        const topic = `bambi/${state.userFingerprint}`;
        state.setPersonalTopic(topic);
        client.subscribe(topic, (err) => {
            if (!err) {
                console.log(`Subscribed to personal topic: ${topic}`);
            } else {
                console.error(`Subscription error to personal topic ${topic}:`, err);
            }
        });
    }
}

client.on('connect', () => {
    subscribeToPersonalTopic();
    client.subscribe('bambi/request_key');
    client.subscribe('bambi/public_key_response');
});

client.on('reconnect', () => console.log('Reconnecting to MQTT broker...'));
client.on('offline', () => console.log('MQTT client is offline'));
client.on('error', (err) => console.error('MQTT error:', err));
client.on('close', () => console.log('Disconnected from MQTT broker'));

client.on('message', (receivedTopic, message) => {
    const messageString = message.toString();
    try {
        const parsedMessage = JSON.parse(messageString);

        if (receivedTopic === state.personalTopic) {
            handlePersonalMessage(parsedMessage);
        } else if (receivedTopic === 'bambi/request_key' && parsedMessage.type === 'requestPublicKey') {
            handleKeyRequest(parsedMessage);
        } else if (receivedTopic === 'bambi/public_key_response' && parsedMessage.type === 'publicKeyResponse') {
            handleKeyResponse(parsedMessage);
        }
    } catch (e) {
        console.error('Error parsing message as JSON or verifying signature:', e);
    }
});

function handlePersonalMessage(parsedMessage: any) {
    if (!parsedMessage.name || !parsedMessage.publicKey) return;

    if (parsedMessage.type === 'playSound' && parsedMessage.soundId) {
        const { name, soundId, publicKey } = parsedMessage;

        console.log(soundId)

        // Play the sound
        const audioUrl = soundUrls.get(soundId);
        if (audioUrl) {
            const audio = new Audio(audioUrl);
            audio.play().catch(e => console.error("Error playing audio:", e));
        } else {
            console.warn(`Sound not found: ${soundId}`);
        }

        // Log the event to the message display
        const senderFingerprint = generateFingerprint(publicKey);
        const friend = state.friendsList.get(senderFingerprint);
        const displayName = friend ? friend.name : name;
        const logMessage = `${displayName} played ${soundId}`;

        state.incomeMessage.push({ message: logMessage, name: 'Event' });
        displayIncomeMessages();

        if (!state.conversations.has(senderFingerprint)) {
            state.conversations.set(senderFingerprint, { name: name });
            renderConversationList();
        }
    } 
}

function handleKeyRequest(parsedMessage: any) {
    const { senderFingerprint, senderName, targetFingerprint } = parsedMessage;

    if (targetFingerprint !== state.userFingerprint || senderFingerprint === state.userFingerprint || !senderFingerprint || !senderName) return;

    if (!state.subsList.has(senderFingerprint)) {
        state.subsList.set(senderFingerprint, { name: senderName, publicKey: '' });
        if (!state.conversations.has(senderFingerprint)) {
            state.conversations.set(senderFingerprint, { name: senderName });
        }
        renderConversationList();
    }

    const responseMessage = {
        type: 'publicKeyResponse',
        senderFingerprint: state.userFingerprint,
        senderName: state.userName,
        publicKey: state.userPublicKey,
        requesterFingerprint: senderFingerprint,
        requesterName: senderName
    };

    client.publish('bambi/public_key_response', JSON.stringify(responseMessage));
}

function handleKeyResponse(parsedMessage: any) {
    const { publicKey, requesterFingerprint } = parsedMessage;
    if (!publicKey || requesterFingerprint !== state.userFingerprint) return;

    const responseSenderFingerprint = generateFingerprint(publicKey);
    const friendNameFromRequest = state.pendingPublicKeyRequests.get(responseSenderFingerprint);

    if (friendNameFromRequest) {
        state.friendsList.set(responseSenderFingerprint, { name: friendNameFromRequest, publicKey: publicKey });
        state.pendingPublicKeyRequests.delete(responseSenderFingerprint);

        if (!state.conversations.has(responseSenderFingerprint)) {
            state.conversations.set(responseSenderFingerprint, { name: friendNameFromRequest });
        }
        renderConversationList();
    }
}
